<template>
  <Modal
    :show="show.generateSummaryConfirm"
    action-text="Generate"
    @close="close"
    @action="confirm"
  >
    <template #title>
      Generate job summary
    </template>

    <template #content>
      This will replace the current job summary (if any) with AI-generated content.
      Are you sure you want to continue?
    </template>
  </Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import Modal from '@/components/shared/Modal.vue';

const { show } = storeToRefs(useModals());
const { setModal } = useModals();

const close = () => setModal({ field: 'generateSummaryConfirm', value: false });

const confirm = () => {
  close();
  useCurrentJobProfile().generateSummaryContent();
};
</script>
